document.addEventListener("DOMContentLoaded", function () {
    let videoTag = document.querySelector("#js-mian-page-video");
  
    if (!videoTag) {
      return;
    }
  
    var video = document.querySelector('.lazy-video')

    video.addEventListener('touchstart', function (e) {
        if (e.target.nodeName === 'VIDEO') {
            if (video.paused) {
                this.play();
            } else {
                this.pause();
            }
        } 
    },{passive: true});

    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy-video"));
  
    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            //   console.log('intersect');
            for (var source in video.target.children) {
              var videoSource = video.target.children[source];
              if (
                typeof videoSource.tagName === "string" &&
                videoSource.tagName === "SOURCE"
              ) {
                videoSource.src = videoSource.dataset.src;
                setTimeout(() => {
                  document.querySelector('.lazy-video').play();
                  
                }, 500);
              }
            }
  
            video.target.load();
            video.target.classList.remove("lazy");
            lazyVideoObserver.unobserve(video.target);
          }
        });
      });
  
      lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
      });
    }
  });
  